import { render, staticRenderFns } from "./ikids_graduate.vue?vue&type=template&id=03ab4ecc&"
import script from "./ikids_graduate.vue?vue&type=script&lang=js&"
export * from "./ikids_graduate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports